import React, {useContext} from 'react'

import Context from './context.jsx'

import Xicon from '../shared/icons/xIcon.jsx'

export default function ErrorPopup({supportEmail = 'support@bybeapp.com'}) {
  const {errorPopup, closeErrorPopup, buttonTextColor} = useContext(Context)

  if (!errorPopup.show) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-70'>
      <div className='relative w-full max-w-md bg-white rounded-md shadow-lg p-6'>
        <button
          onClick={closeErrorPopup}
          className='absolute right-3 top-3 text-gray-400 hover:text-gray-600 focus:outline-none'>
          <Xicon />
        </button>

        <h2 className='pr-6 text-lg font-semibold text-center text-dark'>
          {errorPopup.title}
        </h2>

        <p className='mt-2 text-sm text-center text-gray-600'>
          {errorPopup.message}
        </p>

        {errorPopup.errors?.length > 0 && (
          <>
            <p className='mt-2 text-sm text-center text-red-600'>Error(s):</p>
            <ul className='mt-2 text-sm text-center text-red-600'>
              {errorPopup.errors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </>
        )}

        <p className='mt-4 text-sm text-center text-gray-500'>
          Need help?{' '}
          <a
            href={`mailto:${supportEmail}`}
            className='text-blue-600 underline hover:text-blue-800'>
            {supportEmail}
          </a>
        </p>

        <button
          onClick={closeErrorPopup}
          className={`block w-full mt-4 p-2 rounded-full bg-primary text-center ${buttonTextColor} hover:shadow`}>
          OK
        </button>
      </div>
    </div>
  )
}
